import TalentRelationItem from '../../views/talent/RelationItem.vue';

// モデル関連商品
window.Vue.component('talent-relation-item', TalentRelationItem);
